import { BuildData, SpellMap, SpecMap, SpecRole, TalentMap } from 'web/data/models'
import { CLASS_ID } from 'web/data/general/id'
import { assertDefined } from 'web/utils/utils'
import { CooldownResolver } from 'web/engine/cooldowns/core-resolver'
import { copyTalentPropsToSpell, createBuildData } from 'web/data/core-data'

/*
    This is the build all tests should be ran against. You're free to model
    whatever you want in here.
*/

export const SPEC_ID = {
    DRUID: {
        RESTO: "e44f50f7-1866-4713-a0f6-03ca89c55492",
    }
}

export const SPELL_ID = {
    DRUID: {
        RESTO: {
            TRANQ: "e3f9bc5e-5729-4f9a-86ef-fd4a8dadb74b",
            TREE: "3f0403a0-5384-4c8d-a1f6-3612bce809b8",
        }
    }
}

export const TALENT_ID = {
    DRUID: {
        RESTO: {
            TREE: "00913c5a-9ecc-45ef-a2ff-3fef03fe1c1a",
        }
    }
}

const talents: TalentMap = {

    [TALENT_ID.DRUID.RESTO.TREE]: {
        id: TALENT_ID.DRUID.RESTO.TREE,
        specId: SPEC_ID.DRUID.RESTO,

        name: "Incarnation: Tree of Life",
        shortName: "Tree",

        game_id: 33891,
        icon_name: "ability_druid_improvedtreeform",
    },

}

const spells: SpellMap = {

    [SPELL_ID.DRUID.RESTO.TRANQ]: {
        id: SPELL_ID.DRUID.RESTO.TRANQ,
        name: "Tranquility",
        shortName: "Tranq",
        cooldown: 180,
        talentId: undefined,
        affectedByModifierIds: [],

        game_id: 740,
        icon_name: "spell_nature_tranquility",
        replacedByTalentId: undefined
    },

    [SPELL_ID.DRUID.RESTO.TREE]: {
        id: SPELL_ID.DRUID.RESTO.TREE,
        cooldown: 180,
        affectedByModifierIds: [],

        ...copyTalentPropsToSpell(talents[TALENT_ID.DRUID.RESTO.TREE])
    },

}

const specs: SpecMap = {

    [SPEC_ID.DRUID.RESTO]: {
        id: SPEC_ID.DRUID.RESTO,
        name: "Restoration",
        shortName: "Resto",
        role: SpecRole.Healer,
        classId: CLASS_ID.DRUID,
        spellIds: Object.values(SPELL_ID.DRUID.RESTO),
        talentIds: [],

        game_id: undefined,
        icon_name: undefined,
    }

}

export const Build_1: BuildData = createBuildData({
    buildVersion: '1',
    spells,
    specs,
    talents,
    modifiers: {},

    __CooldownResolver: (spellId: string): CooldownResolver => {
        const spell = spells[spellId]
        assertDefined(spell)

        return (spell) => {
            return spell.cooldown
        }
    },
})
